import axios from "../axios";

const createWithdrawAccount = async function (accessToken, data = {}) {
    try {
        const response = await axios.post('withdraw-account/createWithdrawAccount', data,{
            headers: {
                'Authorization': accessToken
            }
        });
        return response.data;
    }
    catch (e) {
        return {
            success: false,
            errorCode: e.response.status
        }
    }
}

export default createWithdrawAccount;
